import React, { useState, useCallback } from 'react';
import { Box } from '@flexisaf/flexibull2/build/layout';
import { AsyncPaginate } from 'react-select-async-paginate';
import styled, { css } from 'styled-components';

const SelectLabel = styled.div`
  margin-bottom: 8px;
  font-size: 0.9em;
  font-weight: bold;
  text-transform: uppercase;
`;
const SelectWrapper = styled(Box)`
  margin-top: -18px;
`;
const StyledAsyncPaginate = styled(AsyncPaginate)`
  & .css-1okebmr-indicatorSeparator {
    display: none;
  }
  & svg {
    width: 15px;
  }
  > div {
    ${(props) =>
      props.disabled &&
      css`
        background-color: #eceef0;
        border: 1px dashed rgba(216, 216, 227, 0.9);
        cursor: not-allowed;
      `}
  }
`;

export default function AutoLoadSelect(props) {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const onMenuOpen = useCallback(() => {
    setMenuIsOpen(true);
  }, []);

  const onMenuClose = useCallback(() => {
    setMenuIsOpen(false);
  }, []);

  return (
    <SelectWrapper>
      <SelectLabel>{props.label}</SelectLabel>
      <StyledAsyncPaginate
        {...props}
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => props.disabled ? null : onMenuOpen()}
        onMenuClose={() => onMenuClose()}
      />
    </SelectWrapper>
  );
}
